export default "__VITE_ASSET__124dcba3__"